export default "__VITE_ASSET__26mcMLQN__"